
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import UTILS from '@/lib/UTILS';
import { capitalizeFirst } from '@/helpers';
import EditLeadCustomerDialog from '@/components/EditLeadCustomerDialog.vue';
import {
  ContactDetails, Lead, User,
} from '@/types';

@Component({
  components: {
    EditLeadCustomerDialog,
  },
})
export default class LeadCustomerContent extends Vue {
  @Prop(Object) readonly project: undefined | Lead;
  @Prop({ type: Boolean, default: false }) readonly isOperationInfo!: boolean
  @Prop(Object) readonly contactDetails: undefined | ContactDetails;
  @Prop({ type: Boolean, default: false }) readonly hideName!: boolean
  @Prop({ type: Boolean, default: false }) readonly noTooltip!: boolean

  get isProject(): boolean {
    return this.project !== undefined;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get lead(): Lead {
    return this.project ?? this.$store.getters.currentLead;
  }

  // get isPerson() {
  //   return this.type === 'person';
  // }

  // get isBusiness() {
  //   return this.type === 'business';
  // }

  get address() {
    let result = '';

    if (this.street && this.street !== 'hidden') {
      if (this.toponym) result += `${capitalizeFirst(this.toponym)} `;
      if (this.street) result += `${this.street} `;
      if (this.houseNumber) result += `${this.houseNumber} `;
      result += '<br>';
    }
    if (this.postalCode && this.postalCode !== 'hidden') result += `${this.postalCode} `;
    if (this.location) result += `${this.location} `;
    if (this.province) result += `(${this.province.toUpperCase()})`;

    return result;
  }

  // Fatturazione
  get billingAddress() {
    let result = '';

    if (this.billingStreet && this.billingStreet !== 'hidden') {
      if (this.billingToponym) result += `${capitalizeFirst(this.billingToponym)} `;
      if (this.billingStreet) result += `${this.billingStreet} `;
      if (this.billingHouseNumber) result += `${this.billingHouseNumber} `;
      result += '<br>';
    }
    if (this.billingPostalCode && this.billingPostalCode !== 'hidden') result += `${this.billingPostalCode} `;
    if (this.billingLocation) result += `${this.billingLocation} `;
    if (this.billingProvince) result += `(${this.billingProvince.toUpperCase()})`;

    return result;
  }

  // Installazione
  get installationAddress() {
    let result = '';

    if (this.installationStreet && this.installationStreet !== 'hidden') {
      if (this.installationToponym) result += `${capitalizeFirst(this.installationToponym)} `;
      if (this.installationStreet) result += `${this.installationStreet} `;
      if (this.installationHouseNumber) result += `${this.installationHouseNumber} `;
      // if (this.lead.interno) result += `${this.lead.interno}`;
      result += '<br>';
    }
    if (this.installationPostalCode && this.installationPostalCode !== 'hidden') result += `${this.installationPostalCode} `;
    if (this.installationLocation) result += `${this.installationLocation} `;
    if (this.installationProvince) result += `(${this.installationProvince.toUpperCase()})`;

    return result;
  }

  // Contatto

  get type(): string {
    if (this.isProject) return this.lead.tipoCliente || 'person';
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.type;
    return 'person';
  }
  get company(): string | null {
    if (this.isProject) return this.lead.ragioneSociale;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.company;
    return null;
  }
  get VAT(): string | null {
    if (this.isProject) return this.lead.partitaIva;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.VAT;
    return null;
  }
  get companyTaxCode(): string | null {
    if (this.isProject) return this.lead.codiceFiscaleAzienda;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.companyTaxCode;
    return null;
  }
  get firstName(): string | null {
    if (this.isProject) return this.lead.nome;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.firstName;
    return null;
  }
  get lastName(): string | null {
    if (this.isProject) return this.lead.cognome;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.lastName;
    return null;
  }
  get taxCode(): string | null {
    if (this.isProject) return this.lead.codiceFiscale;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.taxCode;
    return null;
  }
  get phone1(): string | null {
    if (this.isProject) return this.lead.telefono;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.phone1;
    return null;
  }
  get phone2(): string | null {
    if (this.isProject) return this.lead.altroTelefono;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.phone2;
    return null;
  }
  get PEC(): string | null {
    if (this.isProject) return this.lead.pec;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.PEC;
    return null;
  }
  get email(): string | null {
    if (this.isProject) return this.lead.email;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.email;
    return null;
  }
  get toponym(): string | null {
    if (this.isProject) return this.lead.toponimo;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.toponym;
    return null;
  }
  get street(): string | null {
    if (this.isProject) return this.lead.indirizzo;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.street;
    return null;
  }
  get houseNumber(): string | null {
    if (this.isProject) return this.lead.civico;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.houseNumber;
    return null;
  }
  get postalCode(): string | null {
    if (this.isProject) return this.lead.cap;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.postalCode;
    return null;
  }
  get location(): string | null {
    if (this.isProject) return this.lead.citta;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.location;
    return null;
  }
  get province(): string | null {
    if (this.isProject) return this.lead.provincia;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.province;
    return null;
  }

  // Fatturazione

  get hasBilling(): boolean {
    if (this.isProject) return this.lead.hasBilling;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.hasBilling;
    return false;
  }
  get billingType(): string {
    if (this.isProject) return this.lead.billingType || 'person';
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingType;
    return 'person';
  }
  get billingCompany(): string | null {
    if (this.isProject) return this.lead.billingCompany;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingCompany;
    return null;
  }
  get billingVAT(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingVAT');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingVAT;
    return null;
  }
  get billingCompanyTaxCode(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingCompanyTaxCode');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingCompanyTaxCode;
    return null;
  }
  get billingFirstName(): string | null {
    if (this.isProject) return this.lead.billingFirstName;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingFirstName;
    return null;
  }
  get billingLastName(): string | null {
    if (this.isProject) return this.lead.billingLastName;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingLastName;
    return null;
  }
  get billingTaxCode(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingTaxCode');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingTaxCode;
    return null;
  }
  get billingPhone1(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingPhone1');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingPhone1;
    return null;
  }
  get billingPhone2(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingPhone2');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingPhone2;
    return null;
  }
  get billingPEC(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingPEC');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingPEC;
    return null;
  }
  get billingEmail(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingEmail');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingEmail;
    return null;
  }
  get billingToponym(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingToponym');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingToponym;
    return null;
  }
  get billingStreet(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingStreet');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingStreet;
    return null;
  }
  get billingHouseNumber(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingHouseNumber');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingHouseNumber;
    return null;
  }
  get billingPostalCode(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingPostalCode');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingPostalCode;
    return null;
  }
  get billingLocation(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingLocation');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingLocation;
    return null;
  }
  get billingProvince(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('billingProvince');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.billingProvince;
    return null;
  }

  // Bolletta

  get hasInstallation(): boolean {
    if (this.isProject) return this.lead.hasInstallation;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.hasInstallation;
    return false;
  }
  get installationType(): string {
    if (this.isProject) return this.lead.installationType;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationType;
    return 'person';
  }
  get installationCompany(): string | null {
    if (this.isProject) return this.lead.installationCompany;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationCompany;
    return null;
  }
  get installationVAT(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationVAT');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationVAT;
    return null;
  }
  get installationCompanyTaxCode(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationCompanyTaxCode');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationCompanyTaxCode;
    return null;
  }
  get installationFirstName(): string | null {
    if (this.isProject) return this.lead.installationFirstName;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationFirstName;
    return null;
  }
  get installationLastName(): string | null {
    if (this.isProject) return this.lead.installationLastName;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationLastName;
    return null;
  }
  get installationTaxCode(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationTaxCode');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationTaxCode;
    return null;
  }
  get installationPhone1(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationPhone1');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationPhone1;
    return null;
  }
  get installationPhone2(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationPhone2');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationPhone2;
    return null;
  }
  get installationPEC(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationPEC');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationPEC;
    return null;
  }
  get installationEmail(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationEmail');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationEmail;
    return null;
  }
  get installationToponym(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationToponym');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationToponym;
    return null;
  }
  get installationStreet(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationStreet');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationStreet;
    return null;
  }
  get installationHouseNumber(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationHouseNumber');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationHouseNumber;
    return null;
  }
  get installationPostalCode(): string | null {
    if (this.isProject) return this.getCustomValueTextByName('installationPostalCode');
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationPostalCode;
    return null;
  }
  get installationLocation(): string | null {
    if (this.isProject) return this.lead.installationLocation;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationLocation;
    return null;
  }
  get installationProvince(): string | null {
    if (this.isProject) return this.lead.installationProvince;
    if (this.isOperationInfo
      && this.contactDetails) return this.contactDetails.installationProvince;
    return null;
  }

  getCustomValueTextByName(name: string): string | null {
    return UTILS.getCustomValueTextByName(this.lead, name) || null;
  }

  getCustomValueBooleanByName(name: string): boolean | null {
    return UTILS.getCustomValueBooleanByName(this.lead, name);
  }

  isBusiness(type = ''): boolean {
    switch (type) {
      case 'billing':
        return this.billingType === 'business';

      case 'installation':
        return this.installationType === 'business';

      default:
        break;
    }

    return this.type === 'business';
  }

  isPerson(type = ''): boolean {
    switch (type) {
      case 'billing':
        return this.billingType === 'person';

      case 'installation':
        return this.installationType === 'person';

      default:
        break;
    }

    return this.type === 'person';
  }
}
